<sol-modal #modal class="recipients-modal" [title]="headerTitle"
    [allowClose]="allowClose"
    [primaryButtonDisabled]="selectedCount === 0"
    (dismissed)="onDismiss()" (closed)="onClose()"
    >
    <sol-omnibar class="omnibar-recipients" (searchQueryChange)="userSearchQueryChange($event)" [itemCountLabel]="recipientCount()" [searchPlaceholderText]="getLocalizationString('Search_Recipient', 'Search recipient')" [isFilterable]="false">
    </sol-omnibar>
    <ag-grid-angular
        #cxoneLoginsToolGrid
        *ngIf="gridOptions"
        [gridOptions]="gridOptions"
        loading
        class="sol-grid recipients-grid ag-theme-balham flex-fill border-0 d-block w-100 logins-grid-height"
    ></ag-grid-angular>
    <sol-modal-footer>
        <div class="d-flex justify-content-end cxone-sol-buttons">
            <sol-button (click)="onClose()" variant="basic">{{cancelLabel}}</sol-button>
            <sol-button variant="primary" [disabled]="(!options?.alwaysEnableSave && selectedCount === 0) || isSendingAwards" (click)="submitLogins()">{{saveLabel}}</sol-button>
        </div>
    </sol-modal-footer>
</sol-modal>